import React from "react";
import Image from "next/image";
import { urls } from "data/links";
import Polaroid1 from "public/assets/akademi/polaroid1.png";
import Polaroid2 from "public/assets/akademi/polaroid2.png";
import Polaroid3 from "public/assets/akademi/polaroid3.png";
import Polaroid4 from "public/assets/akademi/polaroid4.png";
import {
  BannerWrapper,
  BannerContainer,
  BannerTitle,
  BannerBlockCTA,
  BannerImgWrapper,
  PolaroidWrapper1,
  PolaroidWrapper2,
  PolaroidWrapper3,
  PolaroidWrapper4,
  BannerContentWrapper
} from "./akademi-banner.styles";

export const AkademiBanner: React.FC = () => {
  return (
    <BannerWrapper>
      <BannerContainer>
        <BannerContentWrapper>
          <BannerTitle>
            Mempersiapkan generasi muda menghadapi tantangan global
          </BannerTitle>
          <BannerBlockCTA rel="nofollow" href={urls.bambooHr}>
            Gabung di Akademi Guru Juara
          </BannerBlockCTA>
        </BannerContentWrapper>
        <BannerImgWrapper>
          <PolaroidWrapper1>
            <Image src={Polaroid1} alt="Akademi" layout="responsive" />
          </PolaroidWrapper1>
          <PolaroidWrapper2>
            <Image src={Polaroid2} alt="Akademi" layout="responsive" />
          </PolaroidWrapper2>
          <PolaroidWrapper3>
            <Image src={Polaroid3} alt="Akademi" layout="responsive" />
          </PolaroidWrapper3>
          <PolaroidWrapper4>
            <Image src={Polaroid4} alt="Akademi" layout="responsive" />
          </PolaroidWrapper4>
        </BannerImgWrapper>
      </BannerContainer>
    </BannerWrapper>
  );
};
